import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import RetreatRulesComp from '../components/RetreatRulesComp'
import parse from 'html-react-parser';
// added imports for pretty breakdown table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import PaymentComp from '../components/PaymentComp'
import PaypalComp from '../components/PaypalComp';
import PaypalZelle from '../components/PaypalZelle';
import { DataContext } from '../App';
import { fetchPublicEventTypes } from '../api/guestRegistrationService';


const amber = '#B8860A';
const navy = '#1A3A6B';
const pageBg = '#f8f7f2';

const Section = ({ title, children }) => (
    <Box sx={{ border: '1px solid #c8d4de', borderRadius: 1.5, mb: 3, overflow: 'hidden' }}>
        <Box sx={{ bgcolor: '#e4eaf0', borderBottom: '1px solid #c8d4de', px: 3, py: 1.5 }}>
            <Typography sx={{ color: navy, fontWeight: 700, fontSize: '1rem', fontFamily: '"Roboto","Helvetica","Arial",sans-serif', textAlign: 'left' }}>
                {title}
            </Typography>
        </Box>
        <Box sx={{ p: 3 }}>
            {children}
        </Box>
    </Box>
);

export default function PoojaEvent() {
    const [eventData, setEventData] = useState({
        "balaviharYear": "",
        "membershipType": {
            "name": ""
        },
        status: "",
        eventType: '',
        "notes": "first event1",
        "children": [
        ],
        "medical": {
            "pcpName": "",
            "pcpMobile": "",
            "medicalInsurance": "",
            "groupNo": "",
            "idNo": "",
            "medicalNotes": "",
            "medicalConsentSignedBy": "",
            "treatmentConsentSignedBy": ""
        },
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events",
        },
        "events": [
        ],
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""

        }
    });
    const { accessToken, signOut } = useAuth();
    const isGuest = !accessToken;
    const [parentFields, setParentFields] = useState(eventData.parent);
    const [guestErrors, setGuestErrors] = useState({});
    const [otherDonationFlag, setOtherDonationFlag] = useState(false);
    const [selectedAmount, setSelectedAmount] = useState(0);
    const [sponsorship, setSponsorship] = useState(0);
    const [donationEventTypes, setDonationEventTypes] = useState([]);


    const [eventTxnsHistory, setEventTxnsHistory] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [eventFields, setEventFields] = useState([]);
    //const [culturalEventTypes, setCulturalEventTypes] = useState([]);
    const [eventDescription, setEventDescription] = useState("");
    const [ticketPrice, setTicketPrice] = useState(0);
    const [eventTypeId, setEventTypeId] = useState(0);

    const [sessions, setSessions] = useState();
    const [error, setError] = useState(null);
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships } = useMember();
    const [parivarMember, setParivarMember] = useState(false);
    const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember();
    const [inputFields, setInputFields] = useState(eventData.transaction);
    const [medicalFields, setMedicalFields] = useState(eventData.medical);
    const [fullNames, setFullNames] = useState(memberProfile.children ? memberProfile.children.map((child) => child.fullName) : []);
    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
    const [donationEventType, setDonationEventType] = useState(0);
    const [memBvRegdReqd, setMemBvRegdReqd] = useState(); // Membership/Balavihar registration required for event

    useEffect(() => {
        console.log("Token exists or not :", accessToken);
        if (accessToken) {
            memberProfileFetch();
            eventTxnsHistoryFetch();
        }
        // Guests stay on the page — no redirect
    }, [accessToken]);

    // Load event data from the public endpoint for guests
    useEffect(() => {
        if (!accessToken) {
            fetchPublicEventTypes().then((events) => {
                const poojaEvents = events.filter((e) => e.category === 'Pooja');
                if (poojaEvents.length > 0) {
                    const parentEvent = events.find((e) => e.eventTypeId === poojaEvents[0].parentEventTypeId);
                    setDonationEventTypes(poojaEvents);
                    if (parentEvent) {
                        setDonationEventType(parentEvent);
                        setEventData((prev) => ({
                            ...prev,
                            balaviharYear: parentEvent.eventYear,
                            eventType: parentEvent.name,
                        }));
                    }
                }
            }).catch(() => {});
        }
    }, []);

    //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});

    //to populate registered children


    //console.log("Fullnames at the beginning:", fullNames, studentFields);
    const [email, setEmail] = useState("");
    useEffect(() => {
        if (memberProfile.primary) {
            setEmail(memberProfile.primary.email);
        }
    }, []);
    useEffect(() => {
        if (memberProfile.primary) {
            const mobile = memberProfile.primary.mobileNumber.replace(/[-\s]/g, '');
            eventData.parent.firstName = memberProfile.primary.firstName;
            eventData.parent.lastName = memberProfile.primary.lastName;
            eventData.parent.email = memberProfile.primary.email;
            eventData.parent.mobileNumber = mobile;
            setParentFields({
                firstName: memberProfile.primary.firstName,
                lastName: memberProfile.primary.lastName,
                email: memberProfile.primary.email,
                mobileNumber: mobile,
            });
        }
    }, []);

    useEffect(() => {
        if (eventTypes && eventTypes.length > 0) {
            // Filter event types where category is 'Donation'
            const donationEventTypes = eventTypes.filter(eventType => eventType.category === 'Pooja');
            const parentEventType = eventTypes.filter(eventType => eventType.eventTypeId === donationEventTypes[0].parentEventTypeId)[0];

            setDonationEventType(parentEventType);
            setDonationEventTypes(donationEventTypes); // <-- Add this state to hold filtered events

            // Optionally, set a default event type if needed
            if (donationEventTypes.length > 0) {
                eventData.balaviharYear = parentEventType.eventYear;
                eventData.eventType = parentEventType.name;
            }
        }
    }, [eventTypes]);




    // 
    function handleParentChange(e) {
        let newForm = { ...parentFields };
        newForm[e.target.name] = e.target.value;
        setParentFields(newForm);
        eventData.parent = newForm;
    }
    const handleSelectDonation = (e) => {
        setDonation(e.target.value);
        if (e.target.value === 'Other') {
            setOtherDonationFlag(true);
        } else {
            setOtherDonationFlag(false);
        }
        setSelectedAmount(e.target.value);
        console.log("Amount :", e.target.value);
    }
    const handleSelectSponsorship = (e) => {
        const selectedEventTypeId = parseInt(e.target.value, 10);

        const selectedEventType = donationEventTypes.find(
            (eventType) => eventType.eventTypeId === selectedEventTypeId
        );

        if (selectedEventType) {
            setEventTypeId(selectedEventType.eventTypeId);
            setTicketPrice(selectedEventType.price);
            setNoOfPeople(1);
            setSponsorship(selectedEventType.price);

            setEventData(prev => ({
                ...prev,
                events: [{
                    memberId: memberProfile.primary?.memberId || null,
                    eventTypeId: selectedEventType.eventTypeId,
                }],
                transaction: {
                    ...prev.transaction,
                    quantities: 1,
                    itemPrice: selectedEventType.price
                }
            }));
        }
        console.log("Sponsorship Amount :", e.target.value, eventData.events);
    }

    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();

    useEffect(() => {


        eventData.transaction.itemPrice = ticketPrice;
        eventData.transaction.quantities = noOfPeople;
        eventData.transaction.donationAmount = parseInt(donation || 0);
        // Add sponsorship to donation in total calculation

        if (feeEnabled) {
            setTotalAmount(((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        console.log("Run 1 calculate price :", (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, donation, sponsorship, feeEnabled, ticketPrice, eventData.events, memberships.totalAmountPaid, memberships.status, parivarMember]);



    const eventTxnsHistoryFetch = async () => {
        let response, data;
        try {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log("Event history data API call:", response, data.data.eventsHistory.events);

                setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'OTP expired');
                    //handleLogout(); // Logout user
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
        }
    };



    const handleLogout = () => {
        signOut();
        navigate('/');
    };

    const memberProfileFetch = async () => {
        console.log("Membership profile fetch", accessToken);
        let response, data;
        try {
            //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setMemberships(data.data.memberships);
                console.log("Membership data after API call:", data, response);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    handleLogout(); // Logout user
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Membership Profile :", error);
            signOut();
            //navigate('/');
        }
    };


    const validateGuestInfo = () => {
        const errs = {};
        if (!parentFields.firstName.trim()) errs.firstName = 'Required';
        if (!parentFields.lastName.trim()) errs.lastName = 'Required';
        if (!parentFields.email.trim() || !/\S+@\S+\.\S+/.test(parentFields.email)) errs.email = 'Valid email required';
        if (!parentFields.mobileNumber.trim()) errs.mobileNumber = 'Required';
        setGuestErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);

        if (totalAmount <= 0) {
            setError('Please select a sponsorship or enter a donation amount greater than $0.');
            return;
        }

        if (isGuest) {
            if (!validateGuestInfo()) return;
            eventData.parent.firstName = parentFields.firstName;
            eventData.parent.lastName = parentFields.lastName;
            eventData.parent.email = parentFields.email;
            eventData.parent.mobileNumber = parentFields.mobileNumber;

            if (totalAmount > 0) {
                eventData.status = "pending";
                setPayloadData({ ...eventData });
                setCheckout(true);
            } else {
                eventData.status = "paid";
                const guestPayload = {
                    firstName: parentFields.firstName,
                    lastName: parentFields.lastName,
                    email: parentFields.email,
                    phone: parentFields.mobileNumber,
                    eventTypeId: eventTypeId,
                    numTickets: noOfPeople || 1,
                    customFields: null,
                    transaction: {
                        itemPrice: eventData.transaction.itemPrice,
                        donationAmount: 0,
                        totalAmount: 0,
                        paymentStatus: 'free',
                        payerId: '',
                        paymentType: 'Free',
                    },
                };
                fetch(`${API_URL}/guestRegistration`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(guestPayload),
                }).then((res) => {
                    if (res.ok) setSuccess(true);
                    else res.json().then((d) => setError(d.message || 'Registration failed'));
                }).catch(() => setError('Registration failed. Please try again.'));
                setCheckout(true);
            }
            return;
        }

        // Authenticated flow
        if (totalAmount > 0) {
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true);
        }
        setPayloadData(eventData);
        if (sendToServer()) {
            console.log("checkout true");
        } else {
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
                //const response = await fetch(`${API_URL}/events`, {
                const response = await fetch(url_link, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        "x-cmdfw-jwt-token": `${accessToken}`,
                    },
                    body: JSON.stringify(eventData),
                });
                console.log('API response:', response.data);
                if (response.ok) {
                    setCheckout(true);
                    return true; // Success
                }
                if (response.status === 403) {
                    const errorData = await response.json();
                    handleLogout(); // Logout user
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    const errorData = await response.json();
                    console.error('API Error:', errorData);
                    setError(errorData.message);
                    return false; // API call failed
                    //throw new Error(errorData.message || 'API call failed');
                }
            } catch (error) {
                console.error(`Attempt ${attempt + 1} failed:`, error);
                attempt++;

                if (attempt >= maxRetries) {
                    console.error('All retry attempts failed.');
                    setCheckout(false);
                    setError("Failed to send data to the server. Please try again later.");
                    return false; // Return false after all retries fail
                }

                console.log(`Retrying API call... (${attempt}/${maxRetries})`);

            }
        }
    }


    function feeSwitchHandler(e) {
        setError(null); // Clear any existing errors
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked;
    }
    function checkOutEnableHandler(e) {
        setError(null); // Clear any existing errors
        setRulesAccepted(e.target.checked)
    }
    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        const parsed = parseInt(e.target.value, 10);
        const val = isNaN(parsed) || parsed < 0 ? 0 : parsed;
        setInputFields({ ...inputFields, [e.target.name]: val });
        setDonation(val);
    };

    const handleCancel = () => {
        navigate(isGuest ? '/' : '/EventTypesForm');
    };


    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)

    // add these computed line-item values before return
    const ticketQtyNum = parseInt(noOfPeople || 0, 10);
    const ticketUnit = parseFloat(ticketPrice || 0);
    const ticketAmount = Number((ticketQtyNum * ticketUnit).toFixed(2));


    const donationAmountNum = Number(parseFloat(donation || 0).toFixed(2));

    const subtotal = Number((ticketAmount + donationAmountNum).toFixed(2));
    const feeAmount = feeEnabled ? Number((subtotal * 0.03).toFixed(2)) : 0;
    const computedTotal = Number((subtotal + feeAmount).toFixed(2));

    return (
        <Box sx={{ bgcolor: pageBg, minHeight: '100vh', py: 4, px: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: '100%', maxWidth: 760, bgcolor: '#fff', borderRadius: 2, boxShadow: 3, overflow: 'hidden', alignSelf: 'flex-start' }}>

                {/* Page header */}
                <Box sx={{ bgcolor: navy, px: { xs: 3, md: 5 }, py: 3 }}>
                    <Typography variant="h5" sx={{ color: '#fff', fontFamily: 'Georgia, serif', fontWeight: 700, letterSpacing: 0.5 }}>
                        {donationEventType?.name || 'Lakṣmī Samaṣṭi Pūjā'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#c5d8ea', mt: 0.5 }}>
                        CMDFW Event Registration
                    </Typography>
                </Box>

                <Box sx={{ px: { xs: 2, md: 3 }, py: 3 }}>
                    {checkout ? (
                        success ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                                <img src={successIcon} className="Success-icon" alt="success" />
                                <Typography variant="h5" sx={{ color: navy, fontFamily: 'Georgia, serif', mt: 2, mb: 1 }}>
                                    Thank You for Registering!
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#555' }}>
                                    A confirmation email will be sent to <b>{isGuest ? parentFields.email : email}</b>
                                </Typography>
                            </Box>
                        ) : (
                            <Box>
                                <PaypalZelle eventData={eventData} setSuccess={setSuccess} payloadData={payloadData} isGuest={isGuest} eventTypeId={eventTypeId} />
                                <Button variant="outlined" sx={{ mt: 3, borderColor: '#aaa', color: '#555' }} onClick={() => handleBack()}>
                                    Back
                                </Button>
                            </Box>
                        )
                    ) : (
                        <form onSubmit={checkoutHandler}>

                            {/* Event Details */}
                            <Section title="Event Details">
                                <Typography variant="body2" sx={{ color: '#555' }}>
                                    {donationEventType && parse(donationEventType.desc || "")}
                                </Typography>
                            </Section>

                            {/* Membership status (logged-in only) */}
                            {!isGuest && memberships.status === "ACTIVE" && (
                                <Box sx={{ bgcolor: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: 1, p: 2, mb: 3 }}>
                                    <Typography variant="body2">
                                        Membership: <b>Active</b> — {memberships.balaviharPeriod}
                                    </Typography>
                                    <Typography variant="body2">
                                        Type: <b>{memberships.currentMembership?.membershipTypesEntity?.name}</b>
                                    </Typography>
                                </Box>
                            )}

                            {!isGuest && memBvRegdReqd && memberships.status !== "ACTIVE" && (
                                <Box sx={{ bgcolor: '#fff3e0', border: '1px solid #ffcc80', borderRadius: 1, p: 2, mb: 3 }}>
                                    <Typography variant="body2" sx={{ color: '#bf360c', fontWeight: 700, mb: 0.5 }}>
                                        Membership expired
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                                        Please renew your membership for <b>{memberships.balaviharPeriod}</b> before registering.
                                    </Typography>
                                    <Button onClick={handleCancel} variant="outlined" size="small" sx={{ borderColor: amber, color: amber }}>
                                        Cancel
                                    </Button>
                                    <Typography variant="caption" sx={{ display: 'block', mt: 2, color: '#777' }}>
                                        Questions? <a href="mailto:membership@cmdfw.org" style={{ color: amber }}>membership@cmdfw.org</a>
                                    </Typography>
                                </Box>
                            )}

                            {(isGuest || (memBvRegdReqd && memberships.status === "ACTIVE") || !memBvRegdReqd) && (
                                <>
                                    {/* Puja Sponsorship */}
                                    <Section title="Puja Sponsorship">
                                        <FormControl>
                                            <FormLabel id="donation-radio-buttons-group-label" sx={{ color: navy, fontWeight: 600, mb: 1 }}>
                                                Select Sponsorship
                                            </FormLabel>
                                            <RadioGroup
                                                aria-labelledby="donation-radio-buttons-group-label"
                                                value={eventTypeId}
                                                required
                                                onChange={handleSelectSponsorship}
                                                name="donation-radio-buttons-group"
                                            >
                                                {donationEventTypes && donationEventTypes.map((eventType) => (
                                                    <FormControlLabel
                                                        key={eventType.eventTypeId}
                                                        value={eventType.eventTypeId}
                                                        control={<Radio sx={{ '&.Mui-checked': { color: amber } }} />}
                                                        label={`$${eventType.price} (${eventType.name})`}
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Section>

                                    {/* Donor Information */}
                                    <Section title="Donor Information">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth required label="First Name"
                                                    name="firstName" variant="outlined"
                                                    value={parentFields.firstName}
                                                    onChange={handleParentChange}
                                                    error={!!guestErrors.firstName} helperText={guestErrors.firstName} />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth required label="Last Name"
                                                    name="lastName" variant="outlined"
                                                    value={parentFields.lastName}
                                                    onChange={handleParentChange}
                                                    error={!!guestErrors.lastName} helperText={guestErrors.lastName} />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth required label="Email Address" type="email"
                                                    name="email" variant="outlined"
                                                    value={parentFields.email}
                                                    onChange={handleParentChange}
                                                    error={!!guestErrors.email} helperText={guestErrors.email} />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth required label="Mobile" type="number"
                                                    name="mobileNumber" variant="outlined"
                                                    value={parentFields.mobileNumber}
                                                    onChange={handleParentChange}
                                                    error={!!guestErrors.mobileNumber} helperText={guestErrors.mobileNumber} />
                                            </Grid>
                                        </Grid>
                                    </Section>

                                    {/* Payment Summary */}
                                    <Section title="Payment Summary">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    id="donation"
                                                    label="Additional Donation ($)"
                                                    type="number"
                                                    name="donation"
                                                    variant="outlined"
                                                    value={donation}
                                                    onChange={handleDonation}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={feeEnabled} onChange={feeSwitchHandler} name="feeEnabled"
                                                            sx={{ '&.Mui-checked': { color: amber } }} />
                                                    }
                                                    label="Add 3% to cover credit card processing fees"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth disabled
                                                    label="Total Amount ($)"
                                                    type="number"
                                                    variant="outlined"
                                                    inputProps={{ style: { fontSize: 22, fontWeight: 700, color: navy } }}
                                                    InputLabelProps={{ style: { fontSize: 16 } }}
                                                    value={totalAmount}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Section>

                                    {/* Waiver */}
                                    <Section title="Waiver">
                                        <Typography variant="body2" sx={{ mb: 1.5 }}>
                                            Please read the waiver before proceeding:{' '}
                                            <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer" style={{ color: amber }}>
                                                Open PDF
                                            </a>
                                        </Typography>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={rulesAccepted} onChange={checkOutEnableHandler} name="rulesAccepted"
                                                    sx={{ '&.Mui-checked': { color: amber } }} />
                                            }
                                            label="I have read and agree to the rules and policies"
                                        />
                                    </Section>

                                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                                    {/* Action buttons */}
                                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                                        <Button onClick={handleCancel} variant="outlined" sx={{ borderColor: '#bbb', color: '#555', px: 3 }}>
                                            Cancel
                                        </Button>
                                        <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : totalAmount <= 0 ? "Please select a sponsorship or enter a donation" : ""}>
                                            <span>
                                                <Button type="submit" variant="contained" disabled={!rulesAccepted || totalAmount <= 0}
                                                    sx={{ bgcolor: amber, color: '#fff', fontWeight: 700, px: 4,
                                                        '&:hover': { bgcolor: '#9a6f08' },
                                                        '&.Mui-disabled': { bgcolor: '#e8d5a0', color: '#fff' } }}>
                                                    Proceed to Checkout
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </Box>

                                    <Typography variant="caption" sx={{ display: 'block', mt: 3, color: '#999' }}>
                                        Questions? Contact us at{' '}
                                        <a href="mailto:membership@cmdfw.org" style={{ color: amber }}>membership@cmdfw.org</a>
                                    </Typography>
                                </>
                            )}
                        </form>
                    )}
                </Box>
            </Box>
        </Box>
    );
}